module.exports = __webpack_public_path__ + "static/media/1BankNegaraMalaysia.1e3849f8.jpg";